module.exports = __webpack_public_path__ + "080272a78753e98cb4fb91f6632aac0c.svg";